import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import Invoice from "./Invoice";

const InvoiceLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Invoice" />
      <Invoice />
    </MasterLayout>
  );
};

export default InvoiceLayout;
